import { useEffect, useMemo, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';

// third-party
import ReactApexChart from 'react-apexcharts';

// project import
import useConfig from 'hooks/useConfig';
import useMain from 'hooks/useMain';

// chart options
const barChartOptions = (theme) => ({
  chart: {
    type: 'bar'
    // height: 350
  },
  dataLabels: {
    enabled: false
  },
  plotOptions: {
    bar: {
      distributed: true,
      // borderRadius: 4,
      horizontal: true,
      columnWidth: '20%',
      barHeight: '20%'
    }
  },

  fill: {
    colors: [theme.palette.primary.darker, theme.palette.primary.dark, theme.palette.primary.main, theme.palette.primary.light]
  }
});

// ==============================|| APEXCHART - BAR ||============================== //

const BCBarChart = ({ stat, ...rest }) => {
  const theme = useTheme();
  // const series = [{ data: [400, 430, 448, 470] }];
  // const statData = stat.filter(({ StepCode }) => {
  //   return StepCode !== 'TOTAL';
  // });
  const sortedStat = stat.sort(({ Sort: a }, { Sort: b }) => a - b);
  const calTickAmount = () => {
    const maxValue = _.isEmpty(sortedStat) ? 0 : sortedStat[0]?.Count;
    for (let index = 9; index > 0; index--) {
      if (maxValue % index === 0) {
        return index;
      }
    }
  };

  const series = [{ data: sortedStat.map((d) => d?.Count || 0) }];
  const { upperCaseLang } = useMain();
  const statLabel = useMemo(() => sortedStat.map((statDetail) => statDetail[`StepDesc${upperCaseLang}`]), [stat, upperCaseLang]);
  // const statTotal = useMemo(() => sortedStat.map((d) => d?.Count || 0).reduce((p, c) => p + c, 0));
  const { mode } = useConfig();
  const line = theme.palette.divider;
  const { primary } = theme.palette.text;

  const successDark = theme.palette.success.main;

  const [options, setOptions] = useState(barChartOptions(theme));
  useEffect(() => {
    setOptions((prevState) => ({
      ...prevState,
      colors: [successDark],

      // xaxis: {
      //   categories: ['(Hours)']
      // labels: {
      //   style: {
      //     colors: [primary, primary, primary, primary]
      //   }
      // }
      // },
      // annotations: {
      //   xaxis: [
      //     {
      //       x: statTotal,
      //       borderColor: '#00E396',
      //       label: {
      //         borderColor: '#00E396',
      //         style: {
      //           color: '#fff',
      //           background: '#00E396'
      //         }
      //       }
      //     }
      //   ]
      // },
      chart: {
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        customLegendItems: [''],
        markers: {
          width: 0
        }
      },

      xaxis: {
        tickAmount: calTickAmount(),

        categories: statLabel,
        labels: {
          formatter: function (val) {
            return val.toFixed(0);
          },
          style: {
            colors: [primary, primary, primary, primary]
          }
        }
      },
      grid: {
        borderColor: line
      },
      tooltip: {
        theme: mode === 'dark' ? 'dark' : 'light'
      }
    }));
  }, [mode, primary, line, successDark, statLabel]);

  return (
    <div id="chart">
      <ReactApexChart options={options} series={series} type="bar" {...rest} />
    </div>
  );
};

export default BCBarChart;
